import { useContext } from "react";
import { DashboardContext } from "../../../dashboard-context";
import styled from "styled-components";
import moment from "moment";
import { Link } from "react-router-dom";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/DeleteForever";
import { AuthContext } from "../../../../../auth-context";
import { deletePortalSurvey, loadProfile } from "../../../../../api";

const Card = styled.div`
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0px 0px 8px 0px #e1e2e6;
  display: flex;
  justify-content: space-between;
  padding: 10px 16px;
  /* max-width: 1100px; */
  width: 100%;
  margin: 10px 0px;
`;

const MetaData = styled.div`
  display: flex;
  flex-direction: column;
  p {
    font-size: 0.9rem;
  }
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  a {
    color: #000;
    cursor: pointer;
    height: 24px;
    width: 24px;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }

  svg {
    cursor: pointer;
  }
`;

const CopyButton = styled.button`
  background-color: #e5e5e5;
  border-radius: 6px;
  color: #454545;
  padding: 2px 4px;
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 0.8rem;
  font-weight: 500;
  border: none;
  cursor: pointer;

  &:hover {
    background-color: #d5d5d5;
  }
`;

const FormCard = ({ form, forms, setForms }) => {
  const { user, updateUser } = useContext(AuthContext);
  const { openSnackbar } = useContext(DashboardContext);

  const deleteForm = () => {
    deletePortalSurvey(user.id, form.id).then(() => {
      setForms(forms.filter((f) => f.id !== form.id));
      loadProfile(user.id).then((res) => {
        updateUser(res.data.profile);
      });
      openSnackbar("Form deleted", false);
    });
  };

  const handleCopyId = () => {
    navigator.clipboard.writeText(form.share_id);
    openSnackbar("Form ID copied to clipboard", false);
  };

  return (
    <Card>
      <MetaData>
        <h3>{form.name || "Untitled Form"}</h3>
        <p>
          Created {moment.utc(form.created_at).format("MMM D, YYYY")}{" "}
        </p>
      </MetaData>

      <Actions>
        <CopyButton onClick={handleCopyId}>Copy ID</CopyButton>
        <Link to={`/dashboard/forms/edit/${form.id}`}>
          <EditIcon />
        </Link>
        <DeleteIcon onClick={deleteForm} />
      </Actions>
    </Card>
  );
};

export default FormCard;
